import { z } from "zod";

export const localeSchema = z.enum(["th", "en"]);
export type Locale = z.infer<typeof localeSchema>;

export const defaultLocale: Locale = "en";

// Subtitle language code (BCP-47). Normalization happens in @bloom/utils.
export const subtitleLanguageSchema = z.string().min(2).max(12);
export type SubtitleLanguage = z.infer<typeof subtitleLanguageSchema>;
